import React, { useMemo, useState } from 'react';
import bowser from 'yola-bowser';
import useInteractiveAttributes from '../../../../hooks/use-interactive-handler';
import Paragraph from '../../../paragraph';
import InfoWithPopover from '../../../info-with-popover';
import ValueInput from '../../../value-input';
import ColorCircle from '../../../color-circle';
import HorizontalStack from '../../../horizontal-stack';
import { SIZES } from '../../../value-input/constants';
import { convertHSLColorToCssString } from '../../helpers/convert-hsl-color-to-css-string';
import { gradientModelManager } from '../../helpers/gradient-model-manager';
const isTouchDevice = bowser.mobile || bowser.tablet;

const ColorStopControlPanel = ({
  value,
  title,
  popoverProps = undefined,
  arrowPosition,
  onChange = Function.prototype,
  onClick = undefined,
}) => {
  const [isVisible, setIsVisible] = useState(isTouchDevice);

  const isColorPreviewInteractive = onClick != null;
  const displayColor = useMemo(() => convertHSLColorToCssString(value.value), [value.value]);
  const displayAlpha = Number(value.value[3]);
  const displayPosition = gradientModelManager.extractStopPosition(value);

  const handlers = {
    onMouseEnter: () => {
      setIsVisible(true);
    },
    onMouseLeave: () => {
      setIsVisible(false);
    },
  };

  const handleValueChange = (newValue) => {
    const str = String(newValue).replace(/%/g, '');
    const numericValue = parseFloat(str);

    if (Number.isNaN(numericValue)) {
      return;
    }

    onChange({
      id: value.id,
      position: numericValue,
    });
  };

  const handleColorClick = () => {
    onClick?.({
      colorStop: value,
    });
  };

  const interactiveAttributes = useInteractiveAttributes(handleColorClick);

  return (
    <div
      className="ws-ui-gradient-color-stop-control-panel"
      style={{
        '--gradient-color-stop-arrow-position': `${arrowPosition}px`,
      }}
      {...handlers}
    >
      <HorizontalStack verticalAlign="center">
        <Paragraph weight="medium">{title}</Paragraph>
        {isVisible && popoverProps && <InfoWithPopover {...popoverProps} />}
      </HorizontalStack>
      <HorizontalStack verticalAlign="center" gap="spacing-3-xs">
        <ValueInput
          value={`${displayPosition}%`}
          min={0}
          max={100}
          appearance="transparent"
          size={SIZES.tiny}
          align="right"
          supportedUnits={['%']}
          onChange={handleValueChange}
        />
        <div
          className="ws-ui-gradient-color-stop-control-panel__color-preview"
          {...(isColorPreviewInteractive && {
            onClick: handleColorClick,
            ...interactiveAttributes,
          })}
        >
          <ColorCircle color={displayColor} opacity={displayAlpha} />
        </div>
      </HorizontalStack>
    </div>
  );
};

ColorStopControlPanel.displayName = 'ColorStopControlPanel';

export default ColorStopControlPanel;
